var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"headline"}},[_c('div',{staticClass:"d-flex justify-content-center align-items-center flex-wrap flex-sm-nowrap"},[_c('h2',{},[_vm._v(_vm._s(_vm.text)+" ")]),_c('p',{staticClass:"h1 mb-2"})])])}
var staticRenderFns = []

export { render, staticRenderFns }